var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0a1 1 0 011 1v10h10a1 1 0 010 2H13v10a1 1 0 01-2 0V13H1a1 1 0 010-2h10V1a1 1 0 011-1z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconPlus;